import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setGenerateMode,
  setVideoGenerateWarningMessage,
} from "../../../store/common/uiSlice";
import { setLoaderValue } from "../../../store/editor/canvasSlice";
import Loader from "../Loader";
import { setIsOnlyAvatarUrl } from "../../../store/project/projectSlice";
import { storeLocally } from "../../../utils/localStorage";
import { setUserDetails } from "../../../store/user/userSlice";

const GenerateVideoPopover = ({ togglePopup }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loaderValue, uploadMessage, generateLoading } = useSelector(
    (state) => state.canvas
  );
  const trial = useSelector((state) => state?.user?.details?.data?.trial);

  const { generateVideoWarningMessage } = useSelector((state) => state.ui);

  return (
    <>
      <div className="absolute top-0 bottom-0 left-0 right-0 bg-gray-500/40 z-10 ml-0">
        <div
          className="absolute top-16 right-4 z-10 border border-gray-600 shadow-lg rounded-xl shadow-lg overflow-hidden w-1/4  bg-gray-100 space-y-4 p-4"
          onClick={(e) => e.stopPropagation()}
        >
          {generateVideoWarningMessage ? (
            <div className="flex font-bold">{generateVideoWarningMessage}</div>
          ) : (
            <>
              <div className="flex font-bold"> Generate your video </div>
              <div className="flex text-sm">{uploadMessage}</div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100px",
                  height: "100px",
                }}
              >
                <CircularProgressbar
                  value={loaderValue}
                  text={`${loaderValue}%`}
                  counterClockwise={true}
                />
              </div>
            </>
          )}
          <div className="block">
            {generateLoading ? (
              <Loader
                isStack
                hideOverlay
                isDark
                loaderStyle={{
                  margin: "0 0 10px 0",
                }}
              />
            ) : (
              <button
                className="bg-gray-600 text-white hover:bg-black
              hover:bg-black
              text-xs
              text-white
              font-bold
              mr-4
              ml-2
              py-2
              px-4
              rounded
              items-center
              w-full"
                disabled={!!loaderValue && loaderValue != 100}
                onClick={() => {
                  if (!loaderValue || (loaderValue && loaderValue == 100)) {
                    dispatch(setGenerateMode(false));

                    dispatch(setLoaderValue(0));
                    togglePopup();

                    dispatch(setVideoGenerateWarningMessage(""));
                    if (loaderValue && loaderValue == 100) {
                      navigate("/");
                      if (trial) {
                        storeLocally("videos", 0);
                      }
                    }
                  }
                }}
              >
                okay
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default GenerateVideoPopover;
